import UI from "@mile-meeting/mile-ui";
import { TMeetingRoom } from "apis/meetings/meeting-room";
import { Container, ContentContainer, EmptyImage, Info, InfoContainer, LabelContainer } from "./index.styles";
import { useEffect, useRef } from "react";

export default function MeetingRoomHorizontalNonModal({
  meetingRoom,
  open,
  setOpen,
  position = { top: 104, left: 116, bottom: undefined },
  positionFixed = false,
}: {
  meetingRoom: TMeetingRoom;
  open?: boolean;
  setOpen?: (value: boolean) => void;
  position?: { left: number; top?: number; bottom?: number };
  positionFixed?: boolean;
}) {
  const ref = useRef<HTMLDivElement>(null);

  const closeModal = () => {
    const focusedElement = document.activeElement;
    if (focusedElement && focusedElement instanceof HTMLElement) {
      focusedElement.blur();
    }
    setOpen?.(false);
  };

  useEffect(() => {
    const handler = (event: any) => {
      if (open && ref.current && !ref.current.contains(event.target)) {
        closeModal();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [open]);

  return (
    <Container
      style={{
        display: open ? "flex" : "none",
        top: position.top,
        left: position.left,
        bottom: position.bottom,
        position: positionFixed ? "fixed" : "absolute",
      }}
      ref={ref}
    >
      <UI.Typography
        type="body01 normal"
        fontStyle="bold"
        color="var(--alias-color-label-normal)"
        style={{
          whiteSpace: "wrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          maxWidth: "100%",
        }}
      >
        {meetingRoom.name}
      </UI.Typography>
      <ContentContainer>
        {meetingRoom.image && meetingRoom.image !== "" ? (
          <img src={meetingRoom.image} width={120} height={120} style={{ objectFit: "cover", borderRadius: "4px" }} />
        ) : (
          <EmptyImage>
            <UI.Icon name="image" size={24} color="var(--alias-color-label-assistive)" />
          </EmptyImage>
        )}
        <Info>
          <InfoContainer>
            <LabelContainer>
              <UI.Icon name="office" size={16} color="var(--alias-color-label-assistive)" />
              <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-assistive)">
                위치
              </UI.Typography>
            </LabelContainer>
            <UI.Typography
              type="label01"
              fontStyle="regular"
              color="var(--alias-color-label-normal)"
              style={{
                whiteSpace: "wrap",
                overflow: "hidden",
                maxWidth: "100%",
              }}
            >
              {meetingRoom.building?.name ?? ""} {meetingRoom.floor?.name ?? ""}
            </UI.Typography>
          </InfoContainer>
          <InfoContainer>
            <LabelContainer>
              <UI.Icon name="people" size={16} color="var(--alias-color-label-assistive)" />
              <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-assistive)">
                수용 인원
              </UI.Typography>
            </LabelContainer>
            <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
              {meetingRoom.capacity}인
            </UI.Typography>
          </InfoContainer>
          <InfoContainer>
            <LabelContainer>
              <UI.Icon name="notes" size={16} color="var(--alias-color-label-assistive)" />
              <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-assistive)">
                상세 설명
              </UI.Typography>
            </LabelContainer>
            <UI.Typography
              type="label01"
              fontStyle="regular"
              color="var(--alias-color-label-normal)"
              style={{
                whiteSpace: "wrap",
              }}
            >
              {meetingRoom.description}
            </UI.Typography>
          </InfoContainer>
        </Info>
      </ContentContainer>
    </Container>
  );
}
